/*
 * jQuery Unobtrusive Validation - Avoid reload errors
 * Source: https://stackoverflow.com/questions/7493512/jquery-unobtrusive-validation-in-net-mvc-3-showing-success-checkmark
 *
 * Unobtrusive doesn't set settings again if form's data unobtrusiveValidation is set,
 * see the parse function at https://github.com/aspnet/jquery-validation-unobtrusive/blob/master/src/jquery.validate.unobtrusive.js
 * which is still set when reloading after a failed submit.
 * This resets that data so, when reloading after a failed submit, we don't get an error in successMessage.js
 * where we try to reference settings.success supposedly set by unobtrusive.
 *
 */

const unobtrusiveValidation = () => {
  $('form').data('unobtrusiveValidation', null);
  $.validator.unobtrusive.parse('form');
};

export default unobtrusiveValidation;

